import React from "react"

const LogoutIcon = ({ size}) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 26 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17.3333 18.4167L22.75 13M22.75 13L17.3333 7.58333M22.75 13H9.75M13 18.4167C13 19.4241 13 19.9279 12.8893 20.3412C12.5887 21.4627 11.7127 22.3387 10.5912 22.6393C10.1779 22.75 9.67414 22.75 8.66667 22.75H8.125C6.61069 22.75 5.85353 22.75 5.25628 22.5026C4.45994 22.1728 3.82725 21.5401 3.49739 20.7437C3.25 20.1465 3.25 19.3893 3.25 17.875V8.125C3.25 6.61069 3.25 5.85353 3.49739 5.25628C3.82725 4.45994 4.45994 3.82725 5.25628 3.49739C5.85354 3.25 6.61069 3.25 8.125 3.25H8.66667C9.67414 3.25 10.1779 3.25 10.5912 3.36074C11.7127 3.66126 12.5887 4.53729 12.8893 5.65884C13 6.07213 13 6.57586 13 7.58333"
				stroke="#DDE3EE"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>

	)
}

export default LogoutIcon
